import { LETTERS } from "../../qa";
import styles from "./VerificationStatus.module.css";

const LABEL = {
  unverified: "UNVERIFIED",
  correct: "CORRECT ✓",
  incorrect: "INCORRECT ×",
};

export default function VerificationStatus({ question, status, showKey }) {
  const revealed = status !== "unverified" || showKey;
  const key = revealed
    ? `${LETTERS[question.answerIndex]} — ${question.options[question.answerIndex]}`
    : "HIDDEN";

  return (
    <footer className={styles.bar}>
      <div className={styles.cell}>
        <span className={styles.label}>ID</span>
        <span className={styles.value}>{question.id}</span>
      </div>
      <div className={`${styles.cell} ${styles.key}`}>
        <span className={styles.label}>
          {status === "incorrect" ? "Expected answer" : "Answer key"}
        </span>
        <span className={styles.value}>{key}</span>
      </div>
      <div className={`${styles.cell} ${styles[status] ?? ""}`} role="status">
        <span className={styles.label}>
          Status / {status === "unverified" ? "pending" : "verified"}
        </span>
        <span className={styles.value}>{LABEL[status]}</span>
      </div>
    </footer>
  );
}
